import { reportValidationError } from "./reportValidationError";

import type { Schema } from "utils/yup";

import type { ValidationMeta } from "./reportValidationError";

export const softValidate =
  <TType, TContext, TDefault>(yupSchema: Schema<TType, TContext, TDefault>) =>
  // `meta` is passed by RTK Query to `transformResponse` and is only used to
  // name the failing endpoint in the report
  (value: unknown, meta?: ValidationMeta): TType => {
    try {
      // `abortEarly: false` collects every broken field, so the report
      // is not limited to the first one
      return yupSchema.validateSync(value, { abortEarly: false });
    } catch (error) {
      console.error(error);
      reportValidationError(error, meta);

      return value as TType;
    }
  };
